import { useContext } from 'react';

import { InlineNumberInput } from 'src/components/Inputs';
import { InputContext } from 'src/contexts/input.context';
import { mockFn } from 'src/tools/fn.tools';
import { toReqNumber } from 'src/tools/reqNumber.tools';

export interface InlineNumberProps {
  isCurrency?: boolean;
  isPercent?: boolean;
  isReqNumber?: boolean;
  numeralDecimalScale?: number;
}

export function InlineNumber({ isCurrency, isPercent, isReqNumber, numeralDecimalScale }: InlineNumberProps) {
  const {
    classNames,
    value,
    onChange,
    onSubmit = mockFn,
    onDiscard = mockFn,
    isDisabled,
    isReadonly,
    isAutoFocus,
    onClick,
  } = useContext(InputContext);

  function renderValue() {
    if (isPercent) return value * 100;

    if (isReqNumber && isDisabled) return toReqNumber(value);

    return value;
  }

  return (
    <InlineNumberInput
      className={classNames?.input}
      value={renderValue()}
      onChange={onChange}
      onSubmit={onSubmit}
      onDiscard={onDiscard}
      isDisabled={isDisabled}
      isReadonly={isReadonly}
      onClick={onClick}
      autoFocus={isAutoFocus}
      isCurrency={isCurrency}
      isPercent={isPercent}
      stripLeadingZeroes={!isReqNumber}
      numeralDecimalScale={numeralDecimalScale}
    />
  );
}
